module.exports = __webpack_public_path__ + "static/media/ratesbanner.9560ad9f.jpeg";